const API_URL = import.meta.env.VITE_API_URL || (import.meta.env.PROD ? '' : 'http://localhost:3001');

export const getApiUrl = (endpoint: string) => {
    return `${API_URL}${endpoint}`;
};

export const API_BASE_URL = API_URL;
